import React, {Fragment} from 'react'
import Counter from "../../../components/counter";

export default function ScreenBarPartner({context, campagneData, mini}) {

    const partnerMontant = campagneData?.partnerMontant || 1
    const total = campagneData.stats.total.sum.total / partnerMontant

    let bonus = null
    let _objectif = campagneData.objectif
    if (_objectif < total && Array.isArray(campagneData?.bonus) && campagneData?.bonus.length > 0) {
        bonus = campagneData.bonus.find(b => b > total)
        if (!bonus) {
            bonus = campagneData.bonus.at(-1)
        }
    }
    if (bonus) {
        _objectif = bonus
    }

    const percent = (_objectif>0 ? (total / _objectif) * 100 : 0)

    return (
        <Fragment>
            <div className={"d-flex justify-content-around align-items-center"} style={{flexDirection: "column", gap: 0}}>

                <div style={{display: "flex", flexDirection: "column"}}>
                    <span className="brunoy2-counter" style={{
                        marginTop: "-8vh",
                        textAlign: "center",
                        fontSize: "38vh",
                        lineHeight: 1,
                        color: "transparent",
                        backgroundImage: "linear-gradient(180deg, #FFE45C 0%, #FFD028 30%, #E89B14 60%, #C57A0A 100%)",
                        WebkitBackgroundClip: "text",
                        backgroundClip: "text",
                        WebkitTextFillColor: "transparent",
                        filter: "drop-shadow(0 4px 10px rgba(0,0,0,0.55))"
                    }}>
                        <Counter number={total} decimals={0} preserveValue/>
                    </span>
                </div>

                <div style={{
                    marginTop: "-2vh",
                    textAlign: "center",
                    fontFamily: "LustDisplay, serif",
                    fontSize: "10vh",
                    lineHeight: 1,
                    letterSpacing: "0.12em",
                    textTransform: "uppercase",
                    color: "#FFFFFF",
                    filter: "drop-shadow(0 3px 8px rgba(0,0,0,0.5))"
                }}>
                    Mètres carrés
                </div>

                <div style={{
                    backgroundColor: "rgba(255,255,255,0.35)",
                    padding: 0,
                    height: "3.5vh",
                    width: "55vw",
                    borderRadius: 50,
                    overflow: "hidden",
                    marginTop: "4vh"
                }}>
                    <div style={{
                        borderRadius: 50,
                        width: percent + "%",
                        height: "100%",
                        backgroundImage: "linear-gradient(90deg, rgba(255,255,255,0.55) 0%, rgba(255,255,255,0.85) 100%)",
                        transition: "width 1s ease"
                    }}/>
                </div>

            </div>
        </Fragment>
    )
}
